class MotoHero extends HTMLElement {
  connectedCallback() {
    this.art = this.querySelector('[data-moto-tilt]');
    if (!this.art) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (this.reducedMotion) return;

    this.pointer = { x: 0.5, y: 0.36 };
    this.target = { x: 0.5, y: 0.36 };
    this.lastInteraction = 0;
    this.visible = true;

    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerLeave = this.onPointerLeave.bind(this);
    this.tick = this.tick.bind(this);

    this.art.addEventListener('pointermove', this.onPointerMove);
    this.art.addEventListener('pointerleave', this.onPointerLeave);

    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries[0]?.isIntersecting ?? true;
    });
    this.observer.observe(this);

    this.raf = requestAnimationFrame(this.tick);
  }

  disconnectedCallback() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.observer?.disconnect();
  }

  onPointerMove(event) {
    const rect = this.art.getBoundingClientRect();
    this.target.x = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
    this.target.y = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
    this.lastInteraction = performance.now();
  }

  onPointerLeave() {
    this.lastInteraction = 0;
  }

  tick(time) {
    if (!this.visible) {
      this.raf = requestAnimationFrame(this.tick);
      return;
    }

    const idle = !this.lastInteraction || time - this.lastInteraction > 1800;
    if (idle) {
      const t = time / 4200;
      this.target.x = 0.5 + Math.sin(t) * 0.22;
      this.target.y = 0.38 + Math.cos(t * 0.8) * 0.14;
    }

    this.pointer.x += (this.target.x - this.pointer.x) * 0.08;
    this.pointer.y += (this.target.y - this.pointer.y) * 0.08;

    const sx = (this.pointer.x * 100).toFixed(2);
    const sy = (this.pointer.y * 100).toFixed(2);
    const tiltY = ((this.pointer.x - 0.5) * 6).toFixed(2);
    const tiltX = ((0.5 - this.pointer.y) * 4).toFixed(2);

    this.art.style.setProperty('--sx', `${sx}%`);
    this.art.style.setProperty('--sy', `${sy}%`);
    this.art.style.setProperty('--tiltX', `${tiltX}deg`);
    this.art.style.setProperty('--tiltY', `${tiltY}deg`);

    this.raf = requestAnimationFrame(this.tick);
  }
}

if (!customElements.get('moto-hero')) {
  customElements.define('moto-hero', MotoHero);
}
